<template>
  <component :is="activeComponent[accountType]" />
</template>

<script>
import { mapState } from 'vuex';
import * as ACCOUNT from '@/constants/accounts';

const Profile = () => import('./Profile');
const Clan = () => import('./Clan');
const Organization = () => import('./Organization');

export default {
  name: 'AccountSettings',
  computed: {
    ...mapState('current', ['account', 'accountType']),

    activeComponent() {
      return {
        [ACCOUNT.PROFILE]: Profile,
        [ACCOUNT.ORGANIZATION]: Organization,
        [ACCOUNT.CLAN]: Clan,
      };
    },
  },
};
</script>
